export enum PageTabsNames {
  Templates = 'templates',
  MyVideos = 'my_videos',
}
